module.exports = __webpack_public_path__ + "static/img/delivered-icon.3c1b39e0.svg";